import PropTypes from "prop-types";
import React from "react";
import injectSheet from "react-jss";

const styles = () => ({
  container: {
    maxHeight: "3rem"
  },
  svg: {
    height: "1.65rem",
    width: "12rem",
    padding: "0 1rem 0 1rem",
    "@media (max-width: 823px)": {
      paddingLeft: 0,
      marginTop: "0.7rem"
    }
  }
});

const Logo = ({ alt, src, classes }) => (
  <div className={classes.container}>
    <img src={src} alt={alt} className={classes.svg} />
  </div>
);

Logo.propTypes = {
  alt: PropTypes.string,
  src: PropTypes.string.isRequired,
  classes: PropTypes.object
};

export default injectSheet(styles)(Logo);



// WEBPACK FOOTER //
// ./src/components/ProductBar/Logo.jsx